import { useEffect, useState } from 'react'
import _ from 'lodash'
import { routeBookingConstants } from 'utils/constants/route/RouteBookingConstants'

const useRouteParametersForcedGuids = ( route ) => {
	const [ parameters, setParameters ] = useState( {} );
	let routeParameters = _.get( route, [ 'params' ], false );
	
	useEffect(() => {
		let parameters = _.get( route, [ 'params' ], false );
		
		let forcedGuids = {};
		
		for( let forcedGuid of [ routeBookingConstants.FORCED_BUILDING_GUID, routeBookingConstants.FORCED_FLOOR_GUID, routeBookingConstants.FORCED_ROOM_GUID, routeBookingConstants.FORCED_TIMESLOT_GROUP_GUID, routeBookingConstants.THROUGH_QR_SCAN ] ){
			if( _.get( parameters, forcedGuid, false ) !== false  ){
				forcedGuids[ forcedGuid ] = _.get( parameters, forcedGuid );
			}
		}
		
		if( _.get( parameters, routeBookingConstants.FORCED_TIMESLOT_1, false ) !== false  ){
			forcedGuids[ routeBookingConstants.FORCED_TIMESLOTS ] = [];
			for( let i = 1; i <= 20; i++ ){
				if( _.get( parameters, routeBookingConstants[ `FORCED_TIMESLOT_${i}` ], false ) !== false ){
					forcedGuids[ routeBookingConstants.FORCED_TIMESLOTS ].push( _.get( parameters, routeBookingConstants[ `FORCED_TIMESLOT_${i}` ]) );
				}
			}
		}
		
		if( !_.isEqual( forcedGuids, parameters) ){
			setParameters( forcedGuids );
		}
	}, [ routeParameters ] );
	
	return parameters;
}

export default useRouteParametersForcedGuids
